import { Button, Checkbox, Input, Skeleton, Tag } from "antd";
import styled, { css } from "styled-components";

export const Container = styled.div`
  height: 100%;
  position: relative;
`;

export const Header = styled.header`
  padding: 15px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  box-shadow: rgb(0 0 0 / 10%) 0px 1px 8px 0px;
`;

export const RegistrationButton = styled(Button)`
  padding: 0 30px;
`
export const SideBar = styled.div`
  width: 300px;
  background-color: white;
  padding: 14px 16px;
  box-shadow: rgb(0 0 0 / 10%) 0px 8px 8px 0px;
  position: absolute;
  bottom: 0;
  top: 84px;
`;

export const SideBarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const FilterBy = styled.span`
  font-size: 16px;
  color: #262626;
`;

export const ClearFilters = styled(Button)`
  color: #722ED1 !important;
  font-size: 14px !important;
  font-weight: bold !important;
  padding: 0 !important;

  &:hover {
    filter: brightness(60%);
  }
`;

export const FilterInput = styled(Input.Search)``;

export const CategoryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
`;

export const CategoryTitle = styled.span`
  font-size: 16px;
  color: #262626;
`;

export const EditCategory = styled(Button)`
  color: #722ED1 !important;
  font-size: 14px !important;
  font-weight: bold !important;
  padding: 0 !important;

  &:hover {
    filter: brightness(60%);
  }
`;

export const CategoriesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CategoryItem = styled.li`
`;

export const CategoryCheckbox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #722ED1 !important;
    border-color: #722ED1 !important;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;

export const Cards = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  overflow-y: auto;

  ${({ hasNotLinks }) => hasNotLinks && css`
    grid-template-columns: 1fr !important;
  `}

  @media only screen and (min-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (min-width: 1920px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media only screen and (min-width: 2500px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const Card = styled.button`
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background-color: white;
  padding: 14px;
  display: flex;
  gap: 12px;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  text-align: left;

  &:hover {
    border-color: #d9d9d9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

export const CardActions = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.15s ease;

  ${Card}:hover & {
    opacity: 1;
  }
`;

export const FavIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  margin-top: 2px;
  flex-shrink: 0;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: baseline;
`;

export const CardTitle = styled.a`
  color: #722ED1;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  line-height: 1.3;
  z-index: 2;
  text-align: initial;
  word-break: break-word;

  &:hover {
    color: #531dab;
    text-decoration: underline;
  }
`;

export const CardUrl = styled.span`
  font-size: 12px;
  color: #bfbfbf;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  margin-bottom: 4px;
`;

export const CardDescription = styled.span`
  margin-bottom: 6px;
  color: #8C8C8C;
  font-size: 13px;
  text-align: start;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const CardCategory = styled(Tag)`
  margin-top: 4px;
  border-radius: 4px;
`;

export const CardTime = styled.span`
  color: #8C8C8C;
  align-self: flex-end;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  position: absolute;
  bottom: 12px;
  right: 12px;
`;

export const LoadingSkeleton = styled(Skeleton).attrs({
  active: true,
  title: false,
  paragraph: {
    width: '100%',
    rows: 1,
  },
})`
  .ant-skeleton-content .ant-skeleton-paragraph {
    border: 1px solid #e6e6e6;
    max-width: 430px;
    margin-bottom: 0;
  }

  .ant-skeleton-content .ant-skeleton-paragraph li:first-child {
    height: 100px;
    max-width: 430px;
  }
`;
